module.exports = __webpack_public_path__ + "static/media/como-43.22245d07.jpg";